(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-footer"] && !Shopify.designMode) return;
  try {
    
  /* Mobile accordion for Custom Footer */
  (function() {
    /* Open the second column by default on mobile (first is logo, always visible) */
    if (window.innerWidth <= 768) {
      var allCols = document.querySelectorAll('.cf-footer__col');
      if (allCols.length > 1) {
        allCols[1].classList.add('is-open');
      }
    }

    document.querySelectorAll('.cf-footer__heading').forEach(function(heading) {
      heading.addEventListener('click', function() {
        if (window.innerWidth > 768) return;
        var col = heading.closest('.cf-footer__col');
        if (!col) return;
        /* Close siblings */
        var allCols = col.parentElement.querySelectorAll('.cf-footer__col');
        allCols.forEach(function(c) {
          if (c !== col) c.classList.remove('is-open');
        });
        col.classList.toggle('is-open');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
